export type Cue = {
  startTime: string;
  endTime: string;
  text: string;
  class?: string;
  type: "captions" | "subtitles";
};

export type Subtitle = Cue;

export type Caption = Cue;

export type Category = {
  id?: number;
  uuid?: string;
  name: string;
  color: string;
  style?: "italic" | "bold";
};

export function vttToCues(
  vttData: string,
  kind: "captions" | "subtitles",
): Cue[] {
  const cues: Cue[] = [];
  const appliedClassNameRegex = /<c\.([^>]*)>/;

  for (const line of vttData.split("\n\n")) {
    if (line.includes("WEBVTT") || line.includes("STYLE")) continue;

    if (line.includes("-->")) {
      const [first, ...rest] = line.trim().split("\n");
      const [startTime, endTime] = first.split(" --> ");
      const text = rest.join("\n");
      const appliedClassNameMatch = text.match(appliedClassNameRegex);
      cues.push({
        startTime: startTime.split(".")[0],
        endTime: endTime.split(".")[0],
        text:
          new DOMParser().parseFromString(text, "text/html").body.textContent ||
          "",
        // Remove the _ added on the cuesToVTT function
        class: appliedClassNameMatch?.[1].substring(1),
        type: kind,
      });
    }
  }

  return cues;
}

export function cuesToVTT(
  cues: Cue[],
  categoriesMapping: { [className: string]: Category },
): string {
  let vttString = "WEBVTT\n\n\n";

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  for (const [_, { uuid, color, style }] of Object.entries(categoriesMapping)) {
    // The _ is necessary because the class name cannot start with a digit
    vttString += `STYLE\n::cue(._${uuid}) { color: ${color}; ${style ? `font-style: ${style};` : ""} }\n\n`;
  }

  for (let i = 0; i < cues.length; i++) {
    const cue = cues[i];
    const startTime = cue.startTime;
    const endTime = cue.endTime;
    const text = cues[i].class
      ? // The _ is necessary because the class name cannot start with a digit
        `<c._${cues[i].class}>${cue.text.trim()}</c>`
      : cue.text.trim();

    vttString += `${startTime}.001 --> ${endTime}.001\n${text}\n\n`;
  }

  return vttString.trim();
}
